import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { TOAST_DURATION, TOAST_SUCCESS_COLOR } from "../../common/app_constant";
import toast from "react-hot-toast";
import {
  actionQuoteSubmit,
  resetSubmitQuoteList,
} from "./../../routes/app/auth/quotes_list/store/index";
import $ from "jquery";

const QuoteChoosePlanPopup = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit } = useForm();

  const { SubmitQuote } = useSelector((state) => ({
    ...state.quoteListStore,
  }));

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    dispatch(resetSubmitQuoteList());
    if (SubmitQuote?.status == true) {
      toast.success(SubmitQuote.message, {
        duration: TOAST_DURATION,
        position: TOAST_DURATION,
        style: {
          color: TOAST_SUCCESS_COLOR,
        },
      });
      props.handleClose();
      navigate("/neft_details", {
        state: {
          data: props?.policyPreviousData,
          newData: props?.selectedPlan,
        },
      });
      window.location.reload();
    } else if (SubmitQuote?.status == false) {
      toast.error("please try after some time");
    }
  }, [SubmitQuote]);

  return (
    <>
      <div
        class="modal fade show"
        id="modal"
        tabindex="-1"
        aria-labelledby="modalChoosePlan"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalChoosePlan">
                Confirm Quote
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleClose();
                }}
              ></button>
            </div>
            <div class="modal-body">
              {props?.selectedPlan?.plan.name !=
                props?.policyPreviousData?.current_plan &&
              location.state?.from == "policy" ? (
                <div className="text-center">
                  <p>
                    You have selected different plan from your expiring policy.
                    Please proceed ahead to confirm the quote and proceed for
                    next steps.
                  </p>
                </div>
              ) : (
                <>
                  <div className="text-center">
                    <p>
                      We have noted your plan selection. Please proceed ahead to
                      confirm your submission and complete the process.
                    </p>
                  </div>
                </>
              )}
            </div>
            <div class="modal-footer justify-content-center">
              <button
                type="button"
                class="btn btn-secondary"
                onClick={() => {
                  props.handleClose();
                }}
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                onClick={() =>
                  dispatch(
                    actionQuoteSubmit({
                      id: props?.selectedPlan?.id,
                      final_plan: props?.selectedPlan?.plan.name,
                    })
                  )
                }
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QuoteChoosePlanPopup;
